/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _get = require('lodash.get');
var Backbone = require('backbone');
var NProgress = require('nprogress');

var GetDocumentTypesByDepartment = require('common/services/GetDocumentTypesByDepartment');
var GetExamDetailsForEntity = require('../../../common/services/GetExamDetailsForEntity');

var EntityProvideExamFollowUpTaskView = require('./EntityProvideExamFollowUpTaskView');

module.exports = {
  event: 'build:nd:entity-provide-exam-followup',

  channel: 'task',

  builder: function(task) {
    var defer = $.Deferred();

    var examId = _get(task, 'taskData.ND.examId');
    var isAssigned = task.state === 'ASSIGNED';

    $.when(GetExamDetailsForEntity(examId), GetDocumentTypesByDepartment('NON_DEPOSITORY'))
      .done(function(exam, documentTypes) {
        NProgress.set(0.85);

        defer.resolve(
          new EntityProvideExamFollowUpTaskView({
            documentTypes: documentTypes,
            isReadOnly: !isAssigned,
            model: new Backbone.Model({
              task: task,
              taskId: task.taskId,
              exam: exam,
              examId: examId
            })
          })
        );
      })
      .fail(function(err) {
        defer.reject(err);
      });

    return defer.promise();
  }
};
